<script setup lang="ts">
import type { Currency } from '~/types/api'

const props = defineProps<{
  price: number
  currency?: Currency
}>()

const count = defineModel<number>({
  required: true,
})

const userStore = useUser()
const { showPrices } = storeToRefs(userStore)
</script>

<template>
  <div
    class="grid grid-cols-[4rem_1fr] content-center items-center gap-y-4 bg-white py-5 2xl:grid-cols-[5rem_1fr] 2xl:gap-y-6"
  >
    <p
      v-if="showPrices"
      class="font-pragmatica-ext whitespace-nowrap pl-5 font-bold 2xl:pl-7 2xl:text-lg"
    >
      {{ $t('configurator.configurationPrice') }}
    </p>
    <div v-if="showPrices" class="grid grid-cols-3 pl-2 pr-5 2xl:pl-5">
      <p></p>
      <p class="font-pragmatica-ext justify-self-center font-bold 2xl:text-lg">
        {{ formatPrice(props.price, props.currency) }}
        <span class="font-sans text-sm font-normal">
          {{ $t('base.order.withoutVat') }}
        </span>
      </p>
      <!-- <p v-if="showPrices" class="justify-self-end text-sm 2xl:text-base">
        {{
          formatPrice(priceWithVat(props.price), props.currency) +
          ' ' +
          $t('configurator.withVat')
        }}
      </p> -->
    </div>
    <p
      class="font-pragmatica-ext whitespace-nowrap pl-5 font-bold 2xl:pl-7 2xl:text-lg"
    >
      {{ $t('configurator.count') }}
    </p>
    <div
      class="grid grid-cols-3 pl-2 pr-5 2xl:pl-5"
      :class="{
        '!grid-cols-1': !showPrices,
      }"
    >
      <p></p>
      <ProductConfiguratorCounter
        v-model="count"
        class="justify-self-center"
        :class="{
          '!justify-self-end': !showPrices,
        }"
      />
    </div>
    <p
      v-if="showPrices"
      class="font-pragmatica-ext whitespace-nowrap pl-5 font-bold 2xl:pl-7 2xl:text-lg"
    >
      {{ $t('configurator.totalPrice') }}
    </p>
    <div v-if="showPrices" class="grid grid-cols-3 pl-2 pr-5 2xl:pl-5">
      <p></p>
      <p class="font-pragmatica-ext justify-self-center font-bold 2xl:text-lg">
        {{ formatPrice(props.price * count, props.currency) }}
        <span class="font-sans text-sm font-normal">
          {{ $t('base.order.withoutVat') }}
        </span>
      </p>
      <!-- <p class="justify-self-end text-sm 2xl:text-base">
        {{
          formatPrice(priceWithVat(props.price, count), props.currency) +
          ' ' +
          $t('configurator.withVat')
        }}
      </p> -->
    </div>
  </div>
</template>
